import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Fade, FormControl, FormControlLabel, Grid, IconButton, LinearProgress, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Switch, TextField, Tooltip, Typography, Zoom } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import TrameroNew from './TrameroNew';
import { Tramero } from './Tramero';
import { DataGrid, GridRowSelectionModel, GridRowId, GridCsvExportOptions, GridCsvGetRowsToExportParams, GridToolbarContainer, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import TrameroDelete from './TrameroDelete';
import TrameroEdit from './TrameroEdit';
import VillaOutlinedIcon from '@mui/icons-material/VillaOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AddRoadOutlinedIcon from '@mui/icons-material/AddRoadOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import TrameroSearchForm from './TrameroSearchForm';
import { TrameroSearchModel } from './TrameroSearchModel';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntityPermissions from '../components/EntityPermissions';
import EntitySettings from '../components/EntitySettings';
import FeatureManager from '../components/Utilities/FeatureManager';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'tramero' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface ITrameroProps {
    isDialog?: boolean
}

export interface ITrameroState {
    data: Tramero[];
    loading: boolean;
    selectedSex: string;
    openNewForm: boolean;
    openEditForm: boolean;
    openDeleteForm: boolean;
    openImportProgress: boolean;
    selectedTramero: GridRowId[];
    progress: number;
    progressMessage: string;
    checkBoxSelection: boolean;
    errors: string[];
    searchModel: TrameroSearchModel;
    searching: boolean;
}

export default class TrameroView extends React.Component<ITrameroProps, ITrameroState> {
    _file: any;
    _fileContent: Tramero[] = [];
    _errors: string[] = [];

    public constructor(props: ITrameroProps) {
        super(props);

        this.state = {
            data: [],
            selectedSex: 'mujer',
            loading: false,
            openNewForm: false,
            openEditForm: false,
            openDeleteForm: false,
            openImportProgress: false,
            selectedTramero: [],
            checkBoxSelection: false,
            progress: 0,
            progressMessage: '',
            errors: [],
            searchModel: new TrameroSearchModel(),
            searching: false
        };
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Tramero} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.Tramero} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Tramero',
                                url: ''
                            }
                        ]
                    }>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <MyLocationOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className='mainTitle'>
                                    Tramero
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntitySettings entity={Entity.Tramero}/>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className='main'>
                            <TrameroSearchForm onSearch={(searchModel: TrameroSearchModel) => {
                                this.Search(searchModel);
                            }}/>
                            
                            {
                                !this.state.searching && this.state.data.length > 0 && (
                                    <Grid container style={{borderBottom: 'solid 1px #666', marginTop: '40px'}}>
                                        <Grid item xs={4}>
                                            <Typography variant='h6'>Datos</Typography>
                                        </Grid>
                                    </Grid>
                                )
                            }
                            {
                                this.state.loading && (
                                    <div style={{textAlign: 'center', marginTop: '40px'}}>
                                        <CircularProgress />
                                    </div>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length == 0 && this.state.searching && (
                                    <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length > 0 && (
                                    <DataGrid
                                        autoHeight
                                        slots={{ toolbar: CustomToolbar }}
                                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                        rows={this.state.data}
                                        hideFooter={this.state.data.length <= 30}
                                        columns={[
                                            { field: 'comunidadAutonoma', headerName: 'Comunidad Autonoma', width: 200 },
                                            { field: 'provincia', headerName: 'Provincia' },
                                            { field: 'municipio', headerName: 'Municipio' },
                                            { field: 'codigoVia', headerName: 'Código de vía' },
                                            { field: 'tipoVia', headerName: 'Tipo de vía' },
                                            { field: 'nombreVia', headerName: 'Nombre', width: 200 },
                                            { field: 'codigoPostal', headerName: 'Codigo Postal' },
                                            { field: 'par', headerName: 'Par', renderCell: ({ row }) => (
                                                <div>
                                                    {
                                                        row.par && (
                                                            <CheckOutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                        )
                                                    }
                                                    {
                                                        !row.par && (
                                                            <ClearOutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                        )
                                                    }
                                                </div>
                                            ) },
                                            { field: 'primerNumero', headerName: 'Primer Número' },
                                            { field: 'ultimoNumero', headerName: 'Último Número' }
                                        ]}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { page: 0, pageSize: 30 },
                                            },
                                        }}
                                        pageSizeOptions={[30, 60, 100]}
                                        checkboxSelection={this.state.checkBoxSelection}
                                        onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                            this.setState({
                                                selectedTramero: row,
                                                openNewForm: false,
                                                openImportProgress: false,
                                                openDeleteForm: false,
                                                openEditForm: false
                                            });
                                        }}
                                    />
                                )
                            }
                        </Box>
                        <FeatureManager entidad={Entity.Tramero} operacion='Crear'>
                            <Box className='stepper' textAlign={'right'}>
                                {
                                    Common.getUrlParam('isdlg') != "1" && (
                                        <SecurityTrimmer entity={Entity.Tramero} permission={PermissionLevel.Crear}>
                                            <Button variant="contained" onClick={() => {
                                                this.setState(
                                                    {
                                                        openNewForm: true,
                                                        openImportProgress: false,
                                                        openEditForm: false,
                                                        openDeleteForm: false
                                                    }
                                                );
                                            }}>
                                                Importar tramero
                                            </Button>
                                        </SecurityTrimmer>
                                    )
                                }
                                {
                                    Common.getUrlParam('isdlg') == "1" && (
                                        <Button variant="contained" onClick={() => {
                                            console.log(this.state.selectedTramero[0]);
                                            window.opener['trameroId'] = this.state.selectedTramero[0];
                                        }}>
                                            Ok
                                        </Button>
                                    )
                                }
                            </Box>
                        </FeatureManager>
                        <Dialog open={this.state.openNewForm} fullWidth>
                            <DialogTitle>
                                Importación del tramero
                            </DialogTitle>
                            <DialogContent>
                                <Typography variant="body2" color="text.secondary">
                                    ¿Desea realizar una importación del tramero?
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.Save.bind(this)}>OK</Button>
                                <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                            </DialogActions>
                        </Dialog>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private Save(): void {
        let url = `${Common.END_POINT}/masters/tramero/import`;
        $.ajax((
            {
                url: url,
                type: "POST",
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.setState(
                {
                    openNewForm: false,
                    openImportProgress: false,
                    openEditForm: false,
                    openDeleteForm: false
                }
            );
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    openNewForm: false,
                    openImportProgress: false,
                    openEditForm: false,
                    openDeleteForm: false
                }
            );
        });
    }

    private Close(): void {
        this.setState(
            {
                openNewForm: false,
                openImportProgress: false,
                openEditForm: false,
                openDeleteForm: false
            }
        );
    }

    private Search(searchModel: TrameroSearchModel): void {
        console.log('tramero', searchModel);
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/tramero/search`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(searchModel),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    data: response,
                    openNewForm: false,
                    openImportProgress: false,
                    openDeleteForm: false,
                    openEditForm: false,
                    selectedTramero: [],
                    loading: false,
                    progress: 0
                }
            );
        })
    }
}